import { SuspensionStatus as Status } from '@wix/ambassador-membership-api/types';
export { Status as PlanStatus };
export var DemoEventTypes;
(function (DemoEventTypes) {
    DemoEventTypes[DemoEventTypes["SINGLE"] = 1] = "SINGLE";
    DemoEventTypes[DemoEventTypes["LIST"] = 2] = "LIST";
})(DemoEventTypes || (DemoEventTypes = {}));
export var WEEKDAY;
(function (WEEKDAY) {
    WEEKDAY[WEEKDAY["SUNDAY"] = 0] = "SUNDAY";
    WEEKDAY[WEEKDAY["MONDAY"] = 1] = "MONDAY";
    WEEKDAY[WEEKDAY["TUESDAY"] = 2] = "TUESDAY";
    WEEKDAY[WEEKDAY["WEDNESDAY"] = 3] = "WEDNESDAY";
    WEEKDAY[WEEKDAY["THURSDAY"] = 4] = "THURSDAY";
    WEEKDAY[WEEKDAY["FRIDAY"] = 5] = "FRIDAY";
    WEEKDAY[WEEKDAY["SATURDAY"] = 6] = "SATURDAY";
})(WEEKDAY || (WEEKDAY = {}));
export var MONTH;
(function (MONTH) {
    MONTH[MONTH["JANUARY"] = 0] = "JANUARY";
    MONTH[MONTH["FEBRUARY"] = 1] = "FEBRUARY";
    MONTH[MONTH["MARCH"] = 2] = "MARCH";
    MONTH[MONTH["APRIL"] = 3] = "APRIL";
    MONTH[MONTH["MAY"] = 4] = "MAY";
    MONTH[MONTH["JUNE"] = 5] = "JUNE";
    MONTH[MONTH["JULY"] = 6] = "JULY";
    MONTH[MONTH["AUGUST"] = 7] = "AUGUST";
    MONTH[MONTH["SEPTEMBER"] = 8] = "SEPTEMBER";
    MONTH[MONTH["OCTOBER"] = 9] = "OCTOBER";
    MONTH[MONTH["NOVEMBER"] = 10] = "NOVEMBER";
    MONTH[MONTH["DECEMBER"] = 11] = "DECEMBER";
})(MONTH || (MONTH = {}));
export var RECURRENCE_TYPE;
(function (RECURRENCE_TYPE) {
    RECURRENCE_TYPE["DAILY"] = "daily";
    RECURRENCE_TYPE["WEEKLY"] = "weekly";
    RECURRENCE_TYPE["MONTHLY"] = "monthly";
})(RECURRENCE_TYPE || (RECURRENCE_TYPE = {}));
export var MONTHLY_OPTION;
(function (MONTHLY_OPTION) {
    MONTHLY_OPTION["DAY"] = "day";
    MONTHLY_OPTION["WEEKDAY"] = "weekday";
    MONTHLY_OPTION["LAST_WEEKDAY"] = "last_weekday";
})(MONTHLY_OPTION || (MONTHLY_OPTION = {}));
export var OCCURRENCE_FREQUENCY;
(function (OCCURRENCE_FREQUENCY) {
    OCCURRENCE_FREQUENCY["DAILY"] = "daily";
    OCCURRENCE_FREQUENCY["WEEKLY"] = "weekly";
    OCCURRENCE_FREQUENCY["BIWEEKLY"] = "biweekly";
    OCCURRENCE_FREQUENCY["MONTHLY"] = "monthly";
    OCCURRENCE_FREQUENCY["CUSTOM"] = "custom";
})(OCCURRENCE_FREQUENCY || (OCCURRENCE_FREQUENCY = {}));
export var OCCURRENCE_ENDING_TYPE;
(function (OCCURRENCE_ENDING_TYPE) {
    OCCURRENCE_ENDING_TYPE["ENDS_AFTER"] = "ends_after";
    OCCURRENCE_ENDING_TYPE["ENDS_ON"] = "ends_on";
})(OCCURRENCE_ENDING_TYPE || (OCCURRENCE_ENDING_TYPE = {}));
export var NAVIGATION_ROUTE;
(function (NAVIGATION_ROUTE) {
    NAVIGATION_ROUTE["DETAILS"] = "details";
    NAVIGATION_ROUTE["REGISTRATION"] = "form";
    NAVIGATION_ROUTE["SCHEDULE"] = "schedule";
})(NAVIGATION_ROUTE || (NAVIGATION_ROUTE = {}));
//# sourceMappingURL=exported-types.js.map